angular.module('impactx').controller('ErrorDialogController', ErrorDialogController);
ErrorDialogController.$inject = ['$scope', '$mdDialog', 'themeFactory', 'dataGen', '$context', '$location', '$sce', '$timeout', 'BrowserSettings', 'TranslationService'];

function ErrorDialogController($scope, $mdDialog, themeFactory, dataGen, $context, $location, $sce, $timeout, BrowserSettings, TranslationService) {
    var vm = this;
    $scope.theme = themeFactory.getTheme();
    $scope.$sce = $sce;
    $scope.criticalErrors = this.criticalErrors;
    $scope.exception = this.exception;
    $scope.errors = this.errors;
    $scope.warnings = this.warnings;
    $scope.authErrors = this.authErrors;
    $scope.errorLogSent = false;
    $scope.errorLogIsSending = false;
    $scope.isGermanUser = BrowserSettings.isGermanUser;
    $scope.translationService = TranslationService;

    $scope.trns = {
        de: "<p>Entschuldigung, das hätte nicht passieren dürfen. </br>" +
        "Leider kam es im System zu einem unerwarteten Fehler, " +
        "weshalb Ihre Anfrage nicht bearbeitet werden konnte. </br> </p>" +
        "<p>Führen Sie Ihre letzten Arbeitsschritte erneut aus und überprüfen Sie Ihre Eingaben auf Richtigkeit. </p>" +
        "<p>Falls der Fehler erneut auftritt können Sie uns gerne auch einen Fehlerbericht senden.</p>",
        en: "<p>We're sorry. That should not have happened.</br>" +
        "An error occurred while processing your request." +
        "<p>Try to execute your latest task again and verify your inputs. </p>" +
        "<p>You can submit an error report if the error occurs again. </p>"
    };

    $scope.closeDialog = function () {
        vm.handler.alreadyShown = false;
        $mdDialog.hide();
    };

    $scope.sendErrorLog = function () {
        $scope.errorLogIsSending = true;
        var userId = $context.userId.value;
        var errorLog = {
            userId: userId,
            currentRoute: $location.absUrl(),
            stackTrace: $scope.exception,
            userAgent: navigator.userAgent
        };

        dataGen.postAsForm({}, {errorLog: errorLog}, "/error/log", true, true).then(function () {
            $timeout(function () {
                console.log("Error report for user " + userId + " submitted.");
                $scope.errorLogIsSending = false;
                $scope.errorLogSent = true;
            }, 1000);
        })
    };

    function stringifyScope(object) {
        try {
            var simpleObject = {};
            var expressions = ["$parent", "$$childHead", "$$childTail", "$$listeners", "$$listenersCount", "dialogData", "$$nextSibling", "$$prevSibling", "$$watchers", "$resolve"];
            for (var prop in object) {
                if (!object.hasOwnProperty(prop)) {
                    continue;
                }
                if (expressions.indexOf(prop) > -1) {
                    continue;
                }
                if (typeof(object[prop]) === 'function') {
                    continue;
                }
                simpleObject[prop] = object[prop];
            }

            // unfortunatly we need this to check for further circular references
            // note: this will even delete a second appearance of a object even though it's not a circular reference
            var cache = [];
            var result =  JSON.stringify(simpleObject, function(key, value) {
                if (typeof value === 'object' && value !== null) {
                    if (cache.indexOf(value) !== -1) {
                        // circular reference found, discard key
                        return;
                    }
                    cache.push(value);
                }
                return value;
            });
            cache = null;

            return result;

        } catch (e) {
            return e;
        }
    }

    $timeout(function () {
        var errorWrappers =  document.getElementsByClassName("md-dialog-container");
        for (var i = 0; i < errorWrappers.length; i++) {
            if (errorWrappers[i].querySelectorAll("#error-dialog-identifier").length > 0) {
                //needed for tinyMCE...
                errorWrappers[i].style.zIndex = "65536"
            }
        }
    });
}
